import util from './util';

let inSyncingSelectAll = false;

if (typeof HTMLElement !== 'function') {
    const _HTMLElement = () => {};
    _HTMLElement.prototype = HTMLElement.prototype;
    window.HTMLElement = _HTMLElement;
}

(function () {
    window.onbeforeunload = function () {
        window.loader.activate();
    };

    // Safari back-forward cache work around so that the loader bar isn't still in place when the user navigates
    // back using the browser back or forward button in Safari
    // See: http://stackoverflow.com/a/13123626
    window.onpageshow = function (e) {
        if (e.persisted) {
            window.loader.deactivate();
            loading.remove();
        }
    };
}());

(function () {
    [...document.querySelectorAll('[role="tab"][data-concertile]')].forEach((node) => {
        node.addEventListener('click', onTabClick);
    });

    function onTabClick(event) {
        const node = event.currentTarget;
        const controls = document.getElementById(node.getAttribute('aria-controls'));
        const state = util.isElementVisible(controls);
        util.showElement(controls, !state);
    }
}());
(function () {
    window.loader = {};
    window.loader.active = false;
    window.loader.toggle = function () {
        if (window.loader.active) {
            document.getElementById('load').classList.add('d-none');
            window.loader.active = false;
        } else {
            document.getElementById('load').classList.remove('d-none');
            window.loader.active = true;
        }
    };
    window.loader.activate = function () {
        if (window.loader.ignore) {
            delete window.loader.ignore;
            return;
        }
        document.getElementById('load').classList.remove('d-none');
        window.loader.active = true;
    };
    window.loader.deactivate = function () {
        document.getElementById('load').classList.add('d-none');
        window.loader.active = false;
    };
    window.loader.ignoreNextActivate = () => {
        window.loader.ignore = true;
        window.loading.skipNextInvocation();
    };
    document.addEventListener('loader.toggle', window.loader.toggle);
    document.addEventListener('loader.activate', window.loader.activate);
    document.addEventListener('loader.deactivate', window.loader.deactivate);

    Array.prototype.forEach.call(document.querySelectorAll('a[href^=mailto],[data-loader-ignore]'), (link) => {
        link.addEventListener('click', window.loader.ignoreNextActivate);
    });
}());

window.markQuestionChanged = function markQuestionChanged(questionSequence, U_FIELDLIST) {
    if (!U_FIELDLIST) {
        U_FIELDLIST = document.getElementById('U_FIELDLIST');
    }
    if (!U_FIELDLIST) return; // some pages (such as leave application) do not use unifacy U_FIELDLIST
    const list = U_FIELDLIST.value ? U_FIELDLIST.value.split(',') : [];
    if (list.indexOf(questionSequence) === -1) {
        list.push(questionSequence);
        U_FIELDLIST.value = list.join(',');
        return true;
    }
    return false;
};

/*
 * Watch for field modification and add their <input name=????? /> to U_FIELDLIST
 */
document.addEventListener('fieldvaluechange', (e) => {
    const node = e.detail;

    if (node.classList.contains('error')) {
        node.classList.remove('error');
        const error = document.querySelector(`[data-for="${node.id}"]`);
        if (error) error.parentNode.removeChild(error);
    }

    if (node.classList.contains('survey-error')) {
        node.classList.remove('survey-error');
        const cell = document.querySelector(`td[data-answer-sequence="${node.id}"]`);
        if (cell) cell.classList.remove('survey-error');
    }

    let nodeName = node.name && node.name.toString(); // node.name is of type Object.name
    if (!nodeName) return; // skip nameless autocomplete fields that have been de-named.

    let uFieldListElement = null;

    if (nodeName.indexOf('__') !== -1) {
        // If there's an _ separator we're looking at a compound field key, add the
        // question itself with a '_table' flag so the server knows to do the whole table.
        let colId = nodeName.split('__')[0];
        colId = colId.split('-').slice(0, 2).join('-'); // Crop off the field type from the id.
        nodeName = `${colId}__table`;
    } else if (nodeName.indexOf('[') !== -1) { // bulkupdate/editable list field
        const matches = nodeName.match(/^([^[]+)(\[.*])/);

        if (matches) {
            nodeName = matches[1];
            uFieldListElement = document.querySelector(`[name='U_FIELDLIST${matches[2]}']`);
        }
    } else if (nodeName.includes('-select')) { // tick/un-tick "select all" for Optional Recipients
        inSyncingSelectAll = true;
        [...document.querySelectorAll('input[name$=_NOTIFICATION_LIST]')].forEach((element) => {
            const boolChecked = node.checked;

            if (element.checked !== boolChecked) {
                element.checked = boolChecked;
                element.dispatchEvent(new CustomEvent('fieldvaluechange', {
                    bubbles: true,
                    detail: element,
                }));
            }
        });
        inSyncingSelectAll = false;
    } else if (nodeName.endsWith('_NOTIFICATION_LIST') && !inSyncingSelectAll) {
        // when check "Select All", each item will trigger event 'fieldvaluechange'
        // during this round, don't re-sync Select All
        syncSelectAllOptionalRecipients();
    } else if (
        node.classList.contains('instructions-markdown')
        || node.hasAttribute('data-filters')
        || (node.hasAttribute('data-shadow') && nodeName.indexOf('-description') !== -1)
    ) {
        // ignore instructions markdown, autocomplete filters and autocomplete descriptions
        return;
    }

    function syncSelectAllOptionalRecipients() {
        const nodeList = document.querySelectorAll('input[name$=_NOTIFICATION_LIST]');
        const boolAll = Array.from(nodeList).every((ele) => ele.checked);
        const nodeSelect = document.querySelector('input[name$=NOTIFICATION_LIST-select]');
        nodeSelect.checked = boolAll;
    }

    // check for U_FIELDLIST inside form and use that in case there are multiple forms on the page
    if (!uFieldListElement && node.form) {
        const uFieldListElementInsideForm = node.form.querySelector('[name="U_FIELDLIST"]');
        if (uFieldListElementInsideForm) uFieldListElement = uFieldListElementInsideForm;
    }

    window.markQuestionChanged(nodeName, uFieldListElement);
});

(function () {
    function attachInputFieldEventHandlers(node) {
        if (node.hasAttribute('data-field-value-change-every-keyup')) {
            node.addEventListener('keyup', (event) => {
                fireEventFieldvaluechange(event);
            });
            node.addEventListener('paste', (event) => {
                fireEventFieldvaluechange(event);
            });
        }

        node.addEventListener('change', (event) => {
            fireEventFieldvaluechange(event);
        });
    }

    function fireEventFieldvaluechange(event) {
        event.target.dispatchEvent(new CustomEvent('fieldvaluechange', {
            bubbles: true,
            detail: event.target,
        }));
    }

    const bubblyFieldTypes = ['input', 'select', 'textarea'];
    const qsInputFields = bubblyFieldTypes.join(',');

    function init(addedNodes) {

        let inputs = [];

        addedNodes.forEach((newNode) => {
            if (!newNode || !newNode.tagName) return;

            if (bubblyFieldTypes.indexOf(newNode.tagName.toLowerCase()) !== -1) {
                inputs.push(newNode);
            } else if (newNode.querySelector(qsInputFields)) {
                inputs = inputs.concat(Array.from(newNode.querySelectorAll(qsInputFields)));
            }

            // update text in custom input when a file is uploaded
            [...newNode.querySelectorAll('.custom-file-input')].forEach((customFileInput) => {
                customFileInput.addEventListener('change', (evt) => {
                    const fileInput      = evt.target;
                    const fileInputLabel = fileInput.nextElementSibling;
                    const fileName       = fileInput.files[0].name;

                    // update the label
                    fileInputLabel.classList.add('selected');
                    fileInputLabel.innerText = fileName;
                });
            });
        });

        inputs.forEach(attachInputFieldEventHandlers);
    }

    util.initialiseAddedNodes(init);
}());

(function () {
    const query = 'input[aria-autocomplete][role=combobox]';

    function init() {
        let node;
        const nodes = document.querySelectorAll(query);
        let i = 0;

        while ((node = nodes[i++])) {
            node.addEventListener('change', (event) => {
                event.target.dispatchEvent(new CustomEvent('fieldvaluechange', {
                    bubbles: true,
                    detail: event.target,
                }));
            });
        }
    }
    document.addEventListener('DOMContentLoaded', init);

}());

/**
 * uppercase Field
 * @return {[type]} [description]
 */
(function () {
    const fields = document.querySelectorAll('.uppercase');
    for (let i = fields.length - 1; 0 <= i; i--) {
        fields.item(i).addEventListener('change', uppercase);
    }

    function uppercase(event) {
        const node = event.target;
        node.value = node.value.toUpperCase();
    }
}());

(function () {
    const stateOpenAttribute = 'data-section-open';
    const msieOrEdge = isMSIEorEdge();

    function isMSIEorEdge() {
        const ua = window.navigator.userAgent;
        return ua.includes('MSIE ') || ua.includes('Trident') || ua.includes('Edge');
    }

    function toggleConcertinaSection(event, head) {
        head = head || this;

        const { forEach } = Array.prototype;
        const actionIsOpen = head.getAttribute(stateOpenAttribute) !== 'true';
        const toggleAll = event && (event.altKey || event.shiftKey);
        const allSections = util.parent(head, '.section-accordian').querySelectorAll('[data-accordian-entry]');

        const sectionsToOpen = [];
        const sectionsToClose = [];

        if (toggleAll) {
            forEach.call(allSections, (section) => {
                (actionIsOpen ? sectionsToOpen : sectionsToClose).push(section);
            });
            head = null; // don't update address bar
        } else if (actionIsOpen) {
            sectionsToOpen.push(head.parentNode);
            forEach.call(allSections, (section) => {
                if (section !== head.parentNode) {
                    sectionsToClose.push(section);
                }
            });
        } else {
            sectionsToClose.push(head.parentNode);
        }

        const hashAnchors = document.querySelectorAll('[data-add-section-hash]');

        forEach.call(sectionsToClose, (section) => {
            if (head && section === head.parentNode) {
                util.updateHashQueryParam(window.location, 'section', '');
                forEach.call(hashAnchors, (hashAnchor) => {
                    hashAnchor.href = util.removeHashParam(hashAnchor.href, 'section');
                });
            }

            const header = section.querySelector('[data-accordian-header]');
            const content = section.querySelector('[data-accordian-content]');

            if (header.getAttribute(stateOpenAttribute) !== 'true') {
                return;
            }

            header.setAttribute(stateOpenAttribute, false);
            header.classList.remove('open');
            content.style.maxHeight = `${_calculateRealHeight(content)}px`;
            content.style.overflow = 'hidden';
            setTimeout(() => {
                content.style.maxHeight = '0px';
                // ... @transitionEnd => handleCellCollapse()
            }, 10);
        });

        forEach.call(sectionsToOpen, (section) => {
            // We're opening this section
            const header = section.querySelector('[data-accordian-header]');
            const content = section.querySelector('[data-accordian-content]');

            if (head && section === head.parentNode) {
                util.updateHashQueryParam(window.location, 'section', getConcertinaSectionId(header));

                // Add hash params to any anchors with data-add-section-hash
                forEach.call(hashAnchors, (hashAnchor) => {
                    hashAnchor.href = util.addHashParam(hashAnchor.href, 'section', getConcertinaSectionId(header));
                });
            }

            if (header.getAttribute(stateOpenAttribute) === 'true') {
                return;
            }

            header.setAttribute(stateOpenAttribute, true);

            // Begin the CSS transition
            header.classList.add('open');
            util.showElement(content);
            content.style.maxHeight = `${_calculateRealHeight(content)}px`;
            content.style.overflow = 'hidden';
            // ... @transitionEnd => handleCellCollapse()
        });
    }

    function getConcertinaSectionId(header) {
        let node = header;
        while ((node = node.parentNode)) {
            if (node.classList.contains('standard-list')) {
                return node.getAttribute('data-accordian-section') || node.id || '';
            }
        }
        return '';
    }

    function _calculateRealHeight(container) {
        let height = 0;
        Array.prototype.forEach.call(container.children, (child) => {
            const outerHeight = child.getBoundingClientRect().height;
            const marginTop = parseInt(window.getComputedStyle(child).marginTop, 10);
            const marginBottom = parseInt(window.getComputedStyle(child).marginBottom, 10);
            height += outerHeight + marginTop + marginBottom;
        });
        return height;
    }

    function init() {
        addMutationObservers('.cells', handleCellsChanged);
        addEventListeners();
        expandHashSection();
    }

    function addEventListeners() {
        const headers = document.querySelectorAll('[data-accordian-header]');
        Array.prototype.forEach.call(headers, (header) => {
            if (header.hasAttribute('data-non-interactive')) {
                return;
            }
            header.addEventListener('click', toggleConcertinaSection);
        });

        document.addEventListener('selectCellById', (event) => {
            selectCellById(event.detail);
        });

        const sectionEntries = document.querySelectorAll('.section-entries');
        Array.prototype.forEach.call(sectionEntries, (content) => {
            content.addEventListener('transitionend', handleCellCollapse);
            content.addEventListener('webkitTransitionEnd', handleCellCollapse);
        });
    }

    // Kludge to force the section to go back to its original height
    // See GLW-293 issues. If anyone has a better idea, please fix this.
    function handleCellCollapse() {
        const content = this;
        const section = content.parentNode;
        const header = section.querySelector('[data-accordian-header]');

        if (!header) {
            return; // ?
        }

        content.style.overflow = '';

        if (header.getAttribute(stateOpenAttribute) === 'true') {
            content.parentNode.style.maxHeight = '';
            content.style.maxHeight = 'none';
            if (msieOrEdge) {
                // Force IE/Edge to redraw the accordion contents, otherwise some parts of the div
                // won't be rendered unless mouse hovered
                content.style.opacity = '0.99';
                requestAnimationFrame(() => {
                    content.style.opacity = '1';
                });
            }
        } else {
            content.style.maxHeight = '';
            util.showElement(content, false);
        }
    }

    function selectCellById(id) {
        unselectCells();
        const cell = document.getElementById(id);
        if (cell) {
            cell.classList.toggle('selected');
        }
    }

    function unselectCells() {
        [...document.querySelectorAll('.cell,.list-cell.selected')].forEach((node) => {
            node.classList.remove('selected');
        });
    }

    /**
     * The expanded section is stored in the Location (URLUtils) object hash. If
     * this object has a section property then it will be used to open the
     * section when the page loads.
     * @return {Boolean} if the section expanded successfully
     */
    function expandHashSection() {
        const hash = util.parseHashQueryParams(window.location);

        if (hash.section && hash.section !== 'null') {
            const section = document.querySelector(`[data-accordian-section="${hash.section}"]`);
            const toOpen = section && section.querySelector('[data-accordian-header]');

            if (toOpen) {
                setTimeout(() => {
                    toggleConcertinaSection(null, toOpen);
                    section.scrollIntoView();
                    document.body.scrollTop -= 60; // Compensate for fixed header
                }, 400);
            }
        }

        const item = hash.item && document.getElementById(hash.item);
        if (item) {
            setTimeout(() => {
                item.scrollIntoView(false);
                item.classList.toggle('selected');
                return true;
            }, 400);
        }
    }

    /**
     * Given selectors and a callback observe each node in the
     * collection and handle it using the callback
     * @param {String}   selectors CSS selectors
     * @param {Function} callback  callback function to handle the observed
     * node
     */
    function addMutationObservers(selectors, callback) {
        // Watch the for content changes and run init when nodes are added
        const observer = new MutationObserver(callback);
        let idx;
        const els = document.querySelectorAll(selectors);
        for (idx = 0; idx < els.length; idx++) {
            observer.observe(els[idx], { childList: true });
        }
    }

    function handleCellsChanged(records) {
        records.forEach((item) => {
            const entriesContainer = item.target.parentNode;
            entriesContainer.style.height = `${_calculateRealHeight(entriesContainer)}px`;
        });
    }
    document.addEventListener('DOMContentLoaded', init);
}());

(function () {
    function init() {
        let idx;
        const els = document.querySelectorAll('.glyph-toggle-root.glyph-auto-toggle');
        for (idx = 0; idx < els.length; idx++) {
            els[idx].classList.add('toggled');
        }
    }

    document.addEventListener('DOMContentLoaded', init);
}());

const breakpoints = {
    large: '(min-width: 768px)',
    medium: '(min-width: 481px)',
    small: '(max-width: 480px)',
};
window.breakpoints = breakpoints;

// Ensure any non-ajax form submission will have the CSRF token in its body
(function () {
    const forms = document.querySelectorAll('form');
    Array.prototype.forEach.call(forms, (form) => {
        if (form.method !== 'post') {
            return;
        }
        form.addEventListener('submit', () => {
            const csrfInput = document.getElementById('_csrf');
            form.appendChild(csrfInput);
            return true;
        });
    });
}());

// Ensure any non-ajax form submission will have the CSRF token in its body
(function () {
    document.addEventListener('DOMContentLoaded', () => {
        const selector = '.scrolly-page-selector-item[aria-pressed]';
        if (document.querySelector(selector)) {
            util.scrollIntoView(selector);
        }
    });
}());

(function () {
    // Chrome has this odd behaviour where if you set an <select><option disabled selected>
    // it won't be selected. yet if you set the disabled attribute after the page is loaded, the
    // option will stay selected.  Go figure.

    util.each(document.querySelectorAll('[data-js-disable]'), (element) => {
        element.setAttribute('disabled', '');
    });
}());

(function () {
    document.addEventListener('DOMContentLoaded', () => {

        util.each($('[data-row-selector-for]'), (masterCheckbox) => {
            $(masterCheckbox).on('click', toggleAll(masterCheckbox));

            const groupName = masterCheckbox.getAttribute('data-row-selector-for');

            util.each($(`[data-row-selector-of="${groupName}"]`), (checkbox) => {
                $(checkbox).on('click', syncToggle(masterCheckbox));
            });
        });
    });

    function toggleAll(masterCheckbox) {
        const groupName = masterCheckbox.getAttribute('data-row-selector-for');
        return function () {
            util.each($(`[data-row-selector-of="${groupName}"]`), (checkbox) => {
                checkbox.checked = masterCheckbox.checked;
            });
        };
    }

    function syncToggle(masterCheckbox) {
        const groupName = masterCheckbox.getAttribute('data-row-selector-for');
        return function () {
            let isAllSelected = true;
            util.each($(`[data-row-selector-of="${groupName}"]`), (checkbox) => {
                isAllSelected = isAllSelected && checkbox.checked;
            });
            masterCheckbox.checked = isAllSelected;
        };
    }

}());

// If a form is reset ... make sure the special fields are reset too.
(function () {
    document.addEventListener('DOMContentLoaded', init);

    function init() {
        $('form').each((idx, form) => {
            if (!form._resetAnyFunnyFields) {
                form.addEventListener('reset', resetAnyFunnyFields);
                form._resetAnyFunnyFields = true;
            }
        });
    }

    function resetAnyFunnyFields(evt) {
        const form = evt.currentTarget;

        // 'Autocomplete' fields
        $(form).find('[type=hidden][id$="-shadow"]').each((idx, field) => {
            $(field).val('');
        });
    }

}());

/**
 * FormData submitted via AJAX in IE10/11 will be corrupted if:
 *   - last input in form is missing name attribute
 *   - last input in form is type="checkbox" and is unchecked
 *   - last input in form is type="radio" and is unchecked
 *
 * More info: https://blog.yorkxin.org/posts/2014/02/06/ajax-with-formdata-is-broken-on-ie10-ie11/
 */
util.initialiseAddedNodes((nodes) => {
    nodes.forEach((node) => {
        const forms = Array.from(node.querySelectorAll('form'));
        forms.filter((form) => form.childElementCount).forEach((form) => {
            const input = document.createElement('input');
            input.name = 'workaround';
            input.type = 'hidden';
            form.appendChild(input);
        });
    });
});

util.initialiseAddedNodes((nodes) => {
    const resizeTextAreas = () => {
        nodes.forEach((node) => {
            Array.from(node.querySelectorAll('.form-control-resize')).forEach((textarea) => {
                window.autosize(textarea);
                window.autosize.update(textarea);
            });
        });
    };

    if (document.readyState === 'complete') {
        resizeTextAreas();
    } else {
        const listener = () => {
            if (document.readyState === 'complete') {
                resizeTextAreas();
                document.removeEventListener('readystatechange', listener);
            }
        };
        document.addEventListener('readystatechange', listener);
    }
});

util.initialiseAddedNodes((nodes) => {
    nodes.forEach((node) => {
        [...node.querySelectorAll('[data-cancel-path]')].forEach((cancelButton) => {
            cancelButton.addEventListener('click', cancel);
        });
    });
});

function cancel(event) {
    event.preventDefault();
    window.loading.load();
    window.location = event.target.getAttribute('data-cancel-path');
}

// Determines when floating bar is stuck:
// https://davidwalsh.name/detect-sticky
// https://usefulangle.com/post/108/javascript-detecting-element-gets-fixed-in-css-position-sticky
const buttonBars = document.querySelectorAll('.floating-button-bar-sticky');
buttonBars.forEach((el) => {
    if (el) {
        const observer = new IntersectionObserver(
            ([e]) => e.target.classList.toggle('is-floating', e.intersectionRatio < 1),
            { threshold: [1] },
        );
        observer.observe(el);
    }
});

$(() => {
    $('[data-bs-toggle="tooltip"]').tooltip();
});
